module.exports = __webpack_public_path__ + "static/media/wand1.450218bc.png";